import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _EntriesBuffer;
import { PerformanceObserverEntryTypes } from '../../const';
export var BufferWithMaxLength = /*#__PURE__*/function () {
  function BufferWithMaxLength() {
    var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    _classCallCheck(this, BufferWithMaxLength);
    _defineProperty(this, "buffer", []);
    _defineProperty(this, "full", false);
    this.maxLength = maxLength;
  }
  _createClass(BufferWithMaxLength, [{
    key: "push",
    value: function push(item) {
      if (this.full || this.maxLength === this.buffer.length) {
        this.full = true;
        this.buffer.shift();
      }
      this.buffer.push(item);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.buffer;
    }
  }]);
  return BufferWithMaxLength;
}();
export var EntriesBuffer = (_EntriesBuffer = {}, _defineProperty(_EntriesBuffer, PerformanceObserverEntryTypes.LongTask, new BufferWithMaxLength()), _defineProperty(_EntriesBuffer, PerformanceObserverEntryTypes.LayoutShift, new BufferWithMaxLength()), _EntriesBuffer);